import { render, staticRenderFns } from "./ViewComponenteForm.vue?vue&type=template&id=2688a712&scoped=true&"
import script from "./ViewComponenteForm.vue?vue&type=script&lang=js&"
export * from "./ViewComponenteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2688a712",
  null
  
)

export default component.exports